export const SmallCloudIcon = (): JSX.Element => (
  <svg width="173" height="87" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M84.439 81.482c20.287-.11 38.102-7.48 48.407-18.552 2.899.926 6.116 1.433 9.5 1.414 9.727-.052 18.021-4.43 21.35-10.569a8.001 8.001 0 0 0 2.095.265c4.142-.022 7.483-3.175 7.462-7.04-.021-3.867-3.396-6.982-7.538-6.96a7.948 7.948 0 0 0-2.782.514c-3.752-5.497-11.65-9.259-20.766-9.209a32.6 32.6 0 0 0-1.532.044C134.527 13.531 111.454.334 83.999.483 61.66.605 42.32 9.528 32.7 22.503a20.556 20.556 0 0 0-11.603-3.5C9.501 19.064.151 28.741.215 40.615.28 52.49 9.735 62.065 21.332 62.002a20.538 20.538 0 0 0 10.756-3.1c9.463 13.481 29.371 22.705 52.35 22.58Z"
        fill="#DFF0FC"
        fillOpacity=".5"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h173v87H0z" />
      </clipPath>
    </defs>
  </svg>
);
